const SocialIconData = [
  {
    image: "/footerImages/whatsapp.png",
    url: "https://wa.me/972559378556",
  },

  {
    image: "/footerImages/youtube.png",
    url: "https://www.youtube.com/@yesmalot",
  },
];
export default SocialIconData;
